import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

export interface IFormInput {
  fullName: string;
  phoneNumber: string;
  password: string;
  confirmationCode: string;
}

export type FirstStepInput = Pick<
  IFormInput,
  'fullName' | 'phoneNumber' | 'password'
>;
export type SecondStepInput = Pick<IFormInput, 'confirmationCode'>;

export const firstStepSchema = z.object({
  fullName: z
    .string()
    .trim()
    .refine((value) => value.split(' ').filter(Boolean).length >= 2, {
      message: 'Full name must contain your first and last name',
    }),
  phoneNumber: z.string().refine((value) => isPossiblePhoneNumber(value), {
    message: 'Phone number is not valid or too short',
  }),
  password: z
    .string()
    .min(8, 'Password must be at least 8 characters long')
    .regex(/[0-9]/, 'Password must contain at least one digit')
    .regex(
      /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/,
      'Password must contain at least one symbol'
    ),
});

export const secondStepSchema = z.object({
  confirmationCode: z
    .string()
    .min(6, 'Confirmation code must be at least 6 digits'),
});
